import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";

function Home() {

    let navigate = useNavigate()

    const {setLang, getData} = useContext(GlobalContext)
    
    useEffect(() => {
        setLang("")
    })
        
    const go = (lang) => {
        sessionStorage.setItem("LJKLang", lang)
        document.querySelector(".navbar").style.backgroundColor = "white"
        setLang(lang)
        getData(lang)

        navigate("/aboutMe")
    }
    
    return(
        <div className="home">
            <div className="home__div">
                <button className="home__button" onClick={() => go("ingles")}>ENGLISH</button>
                <button className="home__button" onClick={() => go("español")}>ESPAÑOL</button>
            </div>
        </div>
    )
}

export default Home